<template>
  <div>
    <svg :width="iconSize" :height="color" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M18.8636 3L14.3182 7.275V17.725L18.8636 13.45V3ZM7.5 5.85C5.73164 5.7663 3.98282 6.26477 2.5 7.275V21.202C2.51673 21.4568 2.71073 21.6595 2.95455 21.677C3.04545 21.677 3.09091 21.6105 3.18182 21.6105C4.53982 20.9652 6.00855 20.613 7.5 20.575C9.26836 20.4913 11.0172 20.9898 12.5 22C14.0335 21.1137 15.7483 20.6251 17.5 20.575C18.9961 20.5411 20.4778 20.8866 21.8182 21.582C21.8896 21.6147 21.9686 21.6247 22.0455 21.6105C22.2893 21.593 22.4833 21.3903 22.5 21.1355V7.275C21.9481 6.85595 21.3337 6.53495 20.6818 6.325V19.15C19.6506 18.823 18.5775 18.6628 17.5 18.675C15.7483 18.7251 14.0335 19.2137 12.5 20.1V7.275C11.0172 6.26477 9.26836 5.7663 7.5 5.85Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiNuclearMedicineJournals',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>